import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import UserCard from "../components/UserCard";
import { Button } from "../components/ui/button";
import api from "../lib/api";
import { useI18n } from "../context/I18nContext";
import { useCall } from "../context/CallContext";
import { toast } from "sonner";
import { Users, Inbox, Send } from "lucide-react";

export default function Friends() {
  const { t } = useI18n();
  const { callFriend } = useCall();
  const [data, setData] = useState({ friends: [], incoming: [], outgoing: [] });

  const load = () => api.get("/friends").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, []);

  const accept = async (u) => {
    await api.post(`/friends/accept/${u.id}`);
    toast.success(`You and ${u.name} are now friends!`);
    load();
  };

  const Section = ({ title, icon: Icon, list, empty, action, actionState, showStatus, onCall }) => (
    <div className="mt-8">
      <h2 className="text-xl font-heading font-bold tracking-tight flex items-center gap-2">
        <Icon className="w-5 h-5 text-primary" /> {title} <span className="text-muted-foreground font-body font-normal">({list.length})</span>
      </h2>
      {list.length === 0 ? (
        <p className="text-muted-foreground mt-3 text-sm">{empty}</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-4">
          {list.map((u) => (
            <UserCard key={u.id} u={u} actionState={actionState} onAction={action} onCall={onCall} showStatus={showStatus} testid={`friend-${u.id}`} />
          ))}
        </div>
      )}
    </div>
  );

  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10">
        <h1 className="text-3xl sm:text-4xl font-heading font-black tracking-tight">{t("friends.title")}</h1>
        <p className="text-foreground/70 mt-1">{t("friends.sub")}</p>

        {data.incoming.length > 0 && (
          <div className="mt-8">
            <h2 className="text-xl font-heading font-bold tracking-tight flex items-center gap-2">
              <Inbox className="w-5 h-5 text-primary" /> {t("friends.requests")} <span className="text-muted-foreground font-body font-normal">({data.incoming.length})</span>
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-4">
              {data.incoming.map((u) => (
                <div key={u.id} className="rounded-3xl bg-card border border-border shadow-sm p-6" data-testid={`incoming-${u.id}`}>
                  <h3 className="font-heading font-bold text-lg">{u.name}</h3>
                  <p className="text-sm text-muted-foreground">{u.country}</p>
                  <p className="text-sm text-foreground/70 mt-2">{t("card.speaks")}: {u.native_languages.join(", ") || "—"}</p>
                  <Button className="w-full rounded-full mt-4" onClick={() => accept(u)} data-testid={`accept-${u.id}`}>{t("friends.accept")}</Button>
                </div>
              ))}
            </div>
          </div>
        )}

        <Section title={t("friends.friends")} icon={Users} list={data.friends} empty={t("friends.noFriends")} actionState="friend" action={() => {}} showStatus={true} onCall={callFriend} />
        <Section title={t("friends.sent")} icon={Send} list={data.outgoing} empty={t("friends.noSent")} actionState="pending" action={() => {}} />
      </div>
    </div>
  );
}
